// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"d69ffb454b7999b985c3","453":"258a5cb69c306e5eef20","522":"d9ea34722211ba4a024a"}[chunkId] + ".js";
};